import { render, staticRenderFns } from "./whitelist-project.vue?vue&type=template&id=0d685ec8&"
import script from "./whitelist-project.vue?vue&type=script&lang=js&"
export * from "./whitelist-project.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports